import { Check } from "lucide-react";
import { Avatar, Group, Tabs, Text } from "@mantine/core";
import React, { ReactNode } from "react";

type StepperTabsProps = {
  activeIndex: number;
  indexCallback: () => void;
  tabsList: StepperTab[];
};
export type StepperTab = {
  id: string;
  title: string;
  content: ReactNode;
};

const StepperTabs: React.FC<StepperTabsProps> = ({
  activeIndex,
  indexCallback,
  tabsList,
}) => (
  <Tabs
    className="stepper-tabs"
    active={activeIndex}
    onTabChange={indexCallback}
  >
    {tabsList.map((tabItem, index) => (
      <Tabs.Tab
        key={tabItem.id}
        disabled={tabItem.id.length > 0}
        label={
          <Group spacing={7}>
            <Avatar size={18} radius={18}>
              {activeIndex > index ? (
                <Check color="#625df5" size={15} />
              ) : (
                index + 1
              )}
            </Avatar>
            <Text>{tabItem.title}</Text>
          </Group>
        }
        className={activeIndex > index ? "past-stepper" : ""}
      >
        {tabItem.content}
      </Tabs.Tab>
    ))}
  </Tabs>
);

export default StepperTabs;
